<div class="flex flex-col gap-5 p-6">
  <shared-modal-header>
    <ng-container title>
      @if (coverage(); as coverage) {
        <div class="flex flex-wrap items-center gap-x-3 gap-y-1">
          <div class="flex items-center gap-1">
            <span class="text-xl font-bold">{{ coverage.packageCore.name }}</span>
            @if (coverage.packageCore.internalName) {
              <mat-icon
                class="text-neutral-400"
                [matTooltip]="coverage.packageCore.internalName"
                >info_outline</mat-icon
              >
            }
          </div>
          <span class="text-sm text-neutral-400">{{ ("packageConfigurator.label.activeFrom" | translate) + " " + formatDate(coverage.activeFrom) }}</span>
        </div>
      }
    </ng-container>
  </shared-modal-header>

  @if (loading()) {
    <div class="flex justify-center py-6">
      <shared-loader></shared-loader>
    </div>
  } @else if (error()) {
    <div class="flex items-center gap-2">
      <span class="text-error-500">{{ "packageCoverage.message.loadError" | translate }}</span>
      <button
        class="cursor-pointer font-bold text-primary-500 hover:text-primary-600"
        type="button"
        (click)="loadCoverage()"
      >
        {{ "packageConfigurator.action.retry" | translate }}
      </button>
    </div>
  } @else if (coverage(); as coverage) {
    <tasks-member-coverage-options [coverage]="coverage"></tasks-member-coverage-options>
  } @else {
    <p class="text-neutral-500">{{ "packageCoverage.message.noActiveCoverage" | translate }}</p>
  }
</div>
